import { withStyles } from '@material-ui/core';

import DescriptionForm from './component';
import styles from './styles';

export default withStyles(styles)(DescriptionForm);
